{
  "ingestion": {
    "lineVolume": "Line Volume",
    "lineCount": "Line Count",
    "dashboard": {
      "usageWidget": {
        "dataUsage": "Data Usage",
        "dataRetention": "Data retention",
        "dataIngestion": "Data ingestion",
        "seeBreakdown": "See breakdown",
        "popOverUsage": "Usage breakdown",
        "popOverRetention": "Retention breakdown",
        "averageFlowToday": "Average flow today",
        "linesPerSec": "1 line/s",
        "linesPerSec_plural": "{{ formattedCount }} lines/s",
        "estimatedUsage": "Estimated usage",
        "estimatedRetention": "Estimated retention",
        "trialEnds": "Trial Ends",
        "inDays": "in 1 day",
        "inDays_plural": "in {{ count }} days",
        "nextBillingCycle": "Next billing cycle",
        "dayRetention": "Day Retention",
        "planRetention": "Plan Retention",
        "noResults": "There are no records to show"
      },
      "serverErrors": {
        "fetchHistory": "Unable to fetch usage settings. Please try refreshing the page."
      },
      "removeRecipientTitle": "Remove <strong>{{ email, sanitize }}</strong> from the recipients list?",
      "removeRecipientOkTitle": "Yes, remove"
    },
    "usageChart": {
      "title": {
        "retention": "Retained data",
        "ingestion": "Ingested data",
        "ingestion-retention": "Ingested vs retained data",
        "rehydration": "Restored data"
      },
      "legend": {
        "retentionTotal": "Total retained data"
      },
      "titleUsage": "Usage per day",
      "titleStorage": "Usage per day – storage",
      "titleIngestion": "Usage per day – ingestion",
      "allDatesAreUTC": "All dates are UTC",
      "lines": "Lines",
      "data": "Data",
      "parsedData": "Parsed Data",
      "storedData": "Stored Data",
      "monthlyUsageInGb": "Usage is calculated in volume (GB, MB, etc).",
      "monthlyUsageInLines": "Usage is calculated in number of log lines.",
      "billingStartDate": "Billing Start Date",
      "percentTresholdAlert": "{{percent}}% Threshold Alert",
      "linesCount": "{{count}} Lines",
      "noData": "No recent usage data available. Please check back later.",
      "ingestion": "Ingestion",
      "rehydrationToggle": "Include restored data"
    },
    "trends": {
      "usageBreakdownFor": "Usage breakdown for {{ date }}",
      "lastMonthInDays": "Trends",
      "breakdownUnavailable": "Top sources breakdown is not available or still processing.",
      "percentageHint": "The percentage represents the portion of log lines that the Source or App represents in the entire organization. You can see it on a monthly basis or daily basis.",
      "downloadFullLists": "Download full lists",
      "downloadFullListsInJSONFormat": "Download the full lists in JSON format.",
      "topSources": "Top Sources",
      "topApps": "Top Apps",
      "other": "Other",
      "showLastMonth": "Show trends"
    },
    "sourcesBreakdown": {
      "trendsCalculatedByLogLines": "Trends and percentage breakdowns of sources, apps and tags are calculated using the number of log lines.",
      "trendsCalculatedByVolume": "Trends and percentage breakdowns of sources, apps and tags are calculated in volume (GB, MB, etc).",
      "exportAsJson": "Export data as .json",
      "totalFor": "Total for",
      "lines": "lines",
      "organizations": "Organizations",
      "apps": "Apps",
      "sources": "Sources",
      "tags": "Tags",
      "name": "Name",
      "flowrateAvg": "Avg. index rate",
      "previousTotal": "Prev.",
      "currentTotal": "Current",
      "deltaPercentage": "Change",
      "percentageOfTotal": "Usage %",
      "flowrateAvgHint": "Average index flow rate",
      "previousTotalHint": "Total number of lines in the previous 30-day period ({{dates}})",
      "currentTotalHint": "Total number of lines in the current 30-day period ({{dates}})",
      "deltaPercentageHint": "Increase or decrease in the number of lines compared to the previous 30-day period",
      "percentageOfTotalHint": "Percent of total usage",
      "new": "New",
      "stacked": "Stacked",
      "compareToTotal": "Compare to total usage",
      "unitPerSec": "{{ unit }}/sec",
      "allRetentionPeriods": "All retained data"
    },
    "quotas": {
      "title": "Usage Quotas",
      "description": "Control spend by specifying thresholds for the volume of log data to store.",
      "daily": "daily",
      "monthly": "monthly",
      "currentState": {
        "headers": {
          "usageQuota": "Usage Quota",
          "configuration": "Configuration",
          "status": "Status of Triggered Alerts and Exclusion Rules"
        },
        "tooltip": {
          "inactive": "Disabled",
          "active": "Quota(s) set and logs could be excluded when exceeded",
          "danger": "Quota(s) exceeded and logs are being excluded"
        },
        "dailyQuota": "Daily Quota",
        "monthlyQuota": "Monthly Quota",
        "notSet": "Not set",
        "softQuotaSet": "Soft Quota set at <span class='text-nowrap'>{{ value }}</span>.",
        "softQuotaExceeded": "Soft Quota exceeded at <span class='text-nowrap'>{{ value }}</span>.",
        "hardQuotaSet": "Hard Quota set at <span class='text-nowrap'>{{ value }}</span>.",
        "hardQuotaExceeded": "Hard Quota exceeded at <span class='text-nowrap'>{{ value }}</span>.",
        "logsRetainedNoRulesSet": "Logs will be retained and no rules are set to alert or exclude.",
        "logsRetainedRulesSetToAlert": "Logs will be retained and rules are set to alert.",
        "logsCouldBeExcludedTodayNoRulesSet": "Logs could be excluded today but no rules are set to alert or exclude.",
        "logsCouldBeExcludedWithinBillingPeriodNoRulesSet": "Logs could be excluded within this billing period but no rules are set to alert or exclude.",
        "logsRetainedRecipientsAlerted": "Logs will be retained but recipients have been alerted.",
        "logsCouldBeExcludedTodayRulesSetToExclude": "Logs could be excluded today and rules are set to alert and exclude.",
        "logsCouldBeExcludedTodayRulesSetToAlert": "Logs could be excluded today and rules are set to alert.",
        "logsCouldBeExcludedWithinBillingPeriodRulesSetToExclude": "Logs could be excluded within this billing period and rules are set to alert and exclude.",
        "logsCouldBeExcludedWithinBillingPeriodRulesSetToAlert": "Logs could be excluded within this billing period and rules are set to alert.",
        "logsExcludedNoRulesSet": "Logs are being excluded but no rules are set to trigger.",
        "logsExcludedRecipientsAlerted": "Logs are being excluded and recipients have been alerted."
      },
      "setup": {
        "title": "Setup",
        "description": "Use Daily and Monthly quotas to set a hard-limit on the amount of logs stored within an Index per day or per month respectively. Daily quotas reset automatically at midnight UTC. Monthly quotas reset automatically at midnight UTC on the last day of the billing cycle.",
        "usageQuotasTitle": "Usage Quotas:",
        "usageQuotasHint": "Daily and monthly Usage Quotas are required for usage alerts and discard rules. Restored Logs do not count against Usage Quotas",
        "setUsageQuotas": "Set Usage Quotas",
        "editUsageQuotas": "Edit Usage Quotas",
        "dailyUsageQuota": "Daily Usage Quota:",
        "monthlyUsageQuota": "Monthly Usage Quota:",
        "unset": "Unset",
        "storage": {
          "dailyCapCallout": "Logs will not be retained when the <strong>Daily</strong> Quota has been reached. Daily quotas automatically reset at midnight UTC.",
          "monthlyCapCallout": "Logs will not be retained when the <strong>Monthly</strong> Quota has been reached. Monthly quotas automatically reset on the last day of the billing cycle at midnight UTC.",
          "dailyAndMonthlyCapCallout": "Logs will not be retained when the <strong>Daily and Monthly</strong> Quota has been reached. Daily quotas automatically reset at midnight UTC, and Monthly quotas automatically reset on the last day of the billing cycle at midnight UTC."
        },
        "ingestion": {
          "dailyCapCallout": "Logs will not be retained when the <strong>Daily</strong> Quota has been reached. Daily quotas automatically reset at midnight UTC.<br/><strong>NOTE:</strong> Usage Quotas are based on retention only. Ingestion charges will continue to incur after quotas are met.",
          "monthlyCapCallout": "Logs will not be retained when the <strong>Monthly</strong> Quota has been reached. Monthly quotas automatically reset on the last day of the billing cycle at midnight UTC.<br/><strong>NOTE:</strong> Usage Quotas are based on retention only. Ingestion charges will continue to incur after quotas are met.",
          "dailyAndMonthlyCapCallout": "Logs will not be retained when the <strong>Daily and Monthly</strong> Quota has been reached. Daily quotas automatically reset at midnight UTC, and Monthly quotas automatically reset on the last day of the billing cycle at midnight UTC.<br/><strong>NOTE:</strong> Usage Quotas are based on retention only. Ingestion charges will continue to incur after quotas are met."
        },
        "setupModalTitle": "Usage Quotas",
        "setupModalDescription": "Set Daily and Monthly Usage Quotas to base all alerts and discard rules on.",
        "hardCapsTitle": "Don't retain any incoming logs when the Usage Quotas are met.",
        "hardCapsDailyLabel": "Discard logs when the <strong>Daily</strong> Usage Quota is reached until midnight UTC",
        "hardCapsMonthlyLabel": "Discard logs when the <strong>Monthly</strong> Usage Quota is reached until the next billing cycle",
        "hardCapsFooter": "*All discarded logs will be preserved for Live Tail and Alerting.",
        "metaData": "{{ count }} used so far",
        "turnOffDailyRulesCallout": "Changing the <strong>daily</strong> usage quota will result in all daily triggered exclusion rules being turned off. Saving this quota will require manually turning on the rules that still apply.",
        "turnOffMonthlyRulesCallout": "Changing the <strong>monthly</strong> usage quota will result in all monthly triggered exclusion rules being turned off. Saving this quota will require manually turning on the rules that still apply.",
        "turnOffDailyAndMonthlyRulesCallout": "Changing the <strong>daily and monthly</strong> usage quota will result in all daily and monthly triggered exclusion rules being turned off. Saving this quota will require manually turning on the rules that still apply.",
        "lowDailyUsageDiscardLogsCallout": "The <strong>daily</strong> usage quota is lower than today’s usage. Applying this usage quota will immediately result in all incoming logs being discarded until midnight UTC.",
        "lowMonthlyUsageDiscardLogsCallout": "The <strong>monthly</strong> usage quota is lower than this month’s usage. Applying this usage quota will immediately result in all incoming logs being discarded until the last day of the billing cycle at midnight UTC.",
        "lowDailyAndMonthlyUsageDiscardLogsCallout": "The <strong>daily and monthly</strong> usage quotas are lower than today's usage and this month’s usage. Applying this usage quota will immediately result in all incoming logs being discarded until the last day of the billing cycle (the nth) at midnight UTC.",
        "lowDailyUsageApplyRulesCallout": "The <strong>daily</strong> usage quota is lower than today’s usage. Applying this usage quota will immediately result in all daily triggered exclusion rules going into effect if this new quota is applied.",
        "lowMonthlyUsageApplyRulesCallout": "The <strong>monthly</strong> usage quota is lower than this month's usage. Applying this usage quota will immediately result in all monthly triggered exclusion rules going into effect if this new quota is applied.",
        "lowDailyAndMonthlyUsageApplyRulesCallout": "The <strong>daily and monthly</strong> usage quotas are lower than today's usage and this month's usage. Applying this usage quota will immediately result in all daily and monthly triggered exclusion rules going into effect if this new quota is applied.",
        "serverErrors": {
          "getSettings": "Unable to retrieve quota usage settings. Please try refreshing the page.",
          "updateSettings": "Unable to update quota usage settings. Please try refreshing the page.",
          "updateRecipients": "Unable to update usage quotas recipients. Please try refreshing the page.",
          "createRule": "Unable to create exclusion rule. Please try refreshing the page.",
          "updateRule": "Unable to edit exclusion rule. Please try refreshing the page.",
          "toggleRule": "Unable to toggle exclusion rule. Please try refreshing the page.",
          "deleteRule": "Unable to delete the exclusion rule. Please try refreshing the page."
        }
      },
      "recipients": {
        "title": "Alert recipients:",
        "description": "At least one recipient is required to activate Usage Quotas.",
        "email": {
          "label": "1 email selected",
          "label_plural": "{{count}} emails selected",
          "placeholder": "Type or select email recipients...",
          "selectLabel": "Press enter",
          "deselectLabel": "Press enter",
          "deselectBlockedLabel": "Can't remove this value",
          "tagPlaceholder": "Add this email"
        },
        "slack": {
          "label": "1 Slack recipient selected",
          "label_plural": "{{count}} Slack recipients selected",
          "placeholder": "Select Slack recipients...",
          "webhookPlaceholder": "Enter Slack webhook URL...",
          "selectLabel": "Press enter",
          "deselectLabel": "Press enter",
          "tagPlaceholder": "Add this webhook URL",
          "connect": {
            "button": "Add from Slack",
            "description": "Connect to Slack to add a channel."
          }
        }
      },
      "rules": {
        "title": "Triggered Exclusion Rules",
        "description": "Trigger exclusion rules as you approach your organization’s usage quota.",
        "disclaimer": "Note that new rules may take a few minutes to take effect.",
        "dailyRules": "Daily triggered exclusion rules",
        "addDailyRule": "Add daily rule",
        "dailyRulesLimit": "The number of daily rules is limited to {{ number }}",
        "monthlyRulesLimit": "The number of monthly rules is limited to {{ number }}",
        "monthlyRules": "Monthly triggered exclusion rules",
        "addMonthlyRule": "Add monthly rule",
        "noRulesYet": "No rules created yet.",
        "activeRule": "{{ count }} active rule",
        "activeRule_plural": "{{ count }} active rules",
        "disabledRule": "{{ count }} disabled rule",
        "disabledRule_plural": "{{ count }} disabled rules",
        "ofAllowedRules": "of {{ count }} allowed rules",
        "triggerAt": "Trigger at {{ threshold }}%",
        "statusDiscardingNow": "<strong>{{ threshold }}%</strong> of {{ type }} quota reached. This rule is triggered, all matching log lines are being <strong>discarded</strong>",
        "statusDiscardingNowHint": "To keep receiving matching logs, toggle off the <strong>Trigger at {{ threshold }}%</strong> switch. It will take a few minutes to suspend/resume log stream.",
        "statusActiveAndDiscarding": "Matching logs will be discarded once <strong>{{ threshold }}%</strong> of the {{ type }} quota is reached",
        "statusActiveAndAlerting": "Recipients will be alerted once <strong>{{ threshold }}%</strong> of the {{ type }} quota is reached",
        "statusActiveAndAlertingHint": "To discard matching logs, edit this rule to enable the <strong>Discard logs</strong> option.",
        "statusDisabled": "This rule will not trigger once <strong>{{ threshold }}%</strong> of the {{ type }} quota is reached",
        "statusDisabledHint": "Toggle the switch on to trigger this rule when {{ threshold }}% of the {{ type }} quotas is reached.",
        "sources": "Sources",
        "apps": "Apps",
        "query": "Query",
        "discardSetting": "Discard Setting",
        "dropping": "Discard logs once reached",
        "indexonly": "Live Tail & Alerting",
        "deleteTitle": "Delete this Triggered Exclusion Rule from the {{ type, capitalize }} Usage Quota?",
        "deleteHint": "This cannot be undone.",
        "createDailyModalTitle": "Create a Triggered Exclusion Rule for the Daily Quota",
        "editDailyModalTitle": "Edit Triggered Exclusion Rule for the Daily Quota",
        "createMonthlyModalTitle": "Create a Triggered Exclusion Rule for the Monthly Quota",
        "editMonthlyModalTitle": "Edit Triggered Exclusion Rule for the Monthly Quota",
        "editModalDescription": " To define a triggered exclusion rule, first set at which percentage towards the usage quota to apply this exclusion rule. Then, define the exclusion rule criteria and actions.",
        "setRuleThreshold": "Set when an exclusion rule should be triggered",
        "thresholdInputLabel": "Apply this rule at:",
        "thresholdInputHintDaily": "<strong>{{ threshold }}%</strong> of the {{ quota }} {{ unit }} <strong>Daily Usage Quota</strong>",
        "thresholdInputHintMonthly": "<strong>{{ threshold }}%</strong> of the {{ quota }} {{ unit }} <strong>Monthly Usage Quota</strong>",
        "thresholdAlreadyExists": "A <strong>{{ threshold }}%</strong> rule has already been created. The existing rule can be updated with new exclusions.",
        "setRuleFilters": "Set exclusion rule criteria (any logs matching the exclusion criteria will be not be stored)",
        "sourcesInputPlaceholder": "Enter sources to exclude...",
        "appsInputPlaceholder": "Enter apps to exclude...",
        "queryInputPlaceholder": "Exclude lines that match this query...",
        "setRuleActions": "Set exclusion rule actions",
        "actionNotify": "Alert all alert recipients via Email and Slack",
        "actionNotifyHint": "Alert recipients will be alerted as long as this rule is enabled",
        "actionDropDaily": "Discard matching log lines until <strong>midnight UTC</strong>",
        "actionDropMonthly": "Discard matching log lines until the start of the <strong>next monthly billing cycle</strong> (midnight UTC)",
        "actionIndexonly": "Preserve for Live Tail and Alerting",
        "turnedOffAlert": "All {{ type }} rules have been turned off. Manually turn on and update the rules that still apply with the new quota."
      }
    },
    "exclusionRules": {
      "title": "Exclusion Rules",
      "description": "Control what you store by creating exclusion rules. New lines that match an exclusion rule will not be stored and will not count toward your storage quota.",
      "currentState": "{{ count }} rule is active. All matching logs will be excluded.",
      "currentState_plural": "{{ count }} rules are active. All matching logs will be excluded.",
      "noRulesCreated": "No exclusion rules created yet.",
      "noRulesDisclaimer": "New rules may take a few minutes to take effect.",
      "addRule": "Add Rule",
      "createRule": "Create a Rule",
      "defaultTitle": "Untitled Rule",
      "descriptionPlaceholder": "What is this rule for?",
      "apps": "Apps",
      "appsPlaceholder": "Enter apps to exclude...",
      "hosts": "Hosts",
      "hostsPlaceholder": "Enter sources to exclude...",
      "query": "Query",
      "queryPlaceholder": "Exclude lines that match this query",
      "indexonly": "Live-tail and alerting will be preserved.",
      "indexonlyLabel": "Preserve these lines for live-tail and alerting",
      "formTip": "Exclude lines that match <em>all</em> of the following criteria:",
      "deleteTitle": "Delete <strong>{{ name, sanitize }}</strong> exclusion rule?",
      "errors": {
        "unableToFetch": "Unable to fetch exclusion rules at the moment.",
        "unableToToggle": "Unable to toggle the exclusion rule at the moment.",
        "unableToSave": "Unable to save the exclusion rule at the moment.",
        "unableToRemove": "Unable to remove the exclusion rule at the moment."
      }
    },
    "shutoff": {
      "suspendAll": "Suspend <strong>all</strong> incoming data",
      "resumeAll": "Resume <strong>all</strong> incoming data",
      "currentStatus": "Current status:",
      "ingestionSuspended": "ingestion suspended",
      "ingestionResumed": "ingestion resumed",
      "itWillTakeAFewMinutes": "It will take a few minutes before the incoming data stream is suspended or resumed.",
      "confirmTitle": "Do you want to suspend <strong>all</strong> incoming data?",
      "confirmHint": "It may take a few minutes before the incoming data stream is suspended.",
      "confirmOkTitle": "Yes, suspend"
    },
    "indexRateAlerts": {
      "title": "Index Rate Alerts",
      "description": "Configure alerting on unexpected spikes.",
      "indexRateInfo": "Index rate",
      "indexRateInfoTooltip": "The Index Rate counts only the logs that are retained and <strong>paid for</strong>. This rate is the mean of the last rolling hour.",
      "ingestRateInfo": "Ingest rate",
      "ingestRateInfoTooltip": "The Ingest Rate counts <strong>all logs</strong> that come through Live Tail, including excluded and discarded logs. This rate is the mean of the last rolling hour.",
      "indexRateTooltipsCheckLater": "Check later",
      "linesPerSecond": "1 line/s",
      "linesPerSecond_plural": "{{ formatted }} lines/s",
      "thresholdsForms": {
        "indexRateAlertsTitle": "Max lines/s",
        "indexRateAlertsDescription": "Set an index rate threshold to send an alert when the value is exceeded. This might require updating if the average index rate changes over time.",
        "standardDeviationAlertTitle": "Max z-score",
        "standardDeviationAlertDescriptionFirstPart": "Set a threshold to send an alert when the hourly index rate is significantly higher than the monthly mean (in ",
        "standardDeviationAlertDescriptionSecondPart": ", aka std devs).",
        "standardDeviationTerm": "standard deviations",
        "standardDeviationTermTooltip": "The z-score is the count of standard deviations. Standard deviations are measured by taking the hourly index rate averages from 30 rolling days in order to contrast that data against the current hourly average to identify significant spikes.",
        "absoluteThreshold": {
          "placeholder": "Add number",
          "appendLabel": "lines/s"
        },
        "relativeThreshold": {
          "placeholder": "Add number",
          "appendLabel": "std devs",
          "disabledTooltip": "Note: After <strong>at least 30 days</strong> of data has been indexed, check here again to use this feature."
        },
        "saved": "Saved!",
        "clear": "Clear"
      },
      "alertCondition": {
        "title": "Threshold Alerts",
        "independently": "Alert on each threshold separately",
        "together": "Alert only when both thresholds have been exceeded",
        "disabledCallout": "Please set up both thresholds to be able to alert when both have been exceeded"
      },
      "flowchartGraph": {
        "anomalousZone": "Anomalous zone",
        "atLeast30DaysRequired": "After at least 30 days of data being indexed, check here again to see this graph.",
        "scales": {
          "month": "30 days",
          "month_short": "30D",
          "week": "7 days",
          "week_short": "7D",
          "day": "1 day",
          "day_short": "1D"
        },
        "types": {
          "absolute": "Index Rate",
          "relative": "Standard Deviation"
        },
        "absolute": {
          "title": "Average index rate over the last {{ scale }}"
        },
        "relative": {
          "title": "Standard deviations over the last {{ scale }}"
        },
        "legend": {
          "indexRateDaily": "Average index rate (daily)",
          "indexRateHourly": "Average index rate (hourly)",
          "minAndMaxIndexRate": "Min and max index rate (daily)",
          "maxLinesePerSThreshold": "Max lines/s threshold",
          "standardDeviations": "Standard deviations (-1σ to +1σ)",
          "unexpectedGrowthThreshold": " Unexpected growth threshold",
          "noData": "No data"
        }
      },
      "customSchedule": {
        "title": "Custom schedule",
        "description": "Set the days and hours to send alerts",
        "alertsAlwaysActiveMessage": "Alerts will always be active.",
        "alertsAlwaysInactiveMessage": "Alerts will always be inactive.",
        "alertsActiveDaysDetailsMessage": "Alerts will be active {{ days }}",
        "alertsActiveTimesDetailsMessage": "&nbsp;from <b>{{ from }}</b> to <b>{{ to }}</b>"
      },
      "alertFrequency": {
        "title": "Alert frequency",
        "description": "Notify recipients once per hour or once per day (starting from the first passing of the threshold) until the index rate declines back below the thresholds, ceasing all alerts.",
        "hourly": "Hourly",
        "daily": "Daily"
      },
      "recipients": {
        "title": "Alert recipients",
        "description": "Add recipients to alert when the configured thresholds are exceeded. The alert message will include data on the sources and apps that have had the largest index rate growth in the past 2 hours, as well as a list of the newest sources added.",
        "slackButton": "Add Slack",
        "emailButton": "Add Email",
        "pdButton": "Add PagerDuty",
        "webhookButton": "Add Webhook",
        "webhookBtnSave": "Save Webhook",
        "webhookBtnSaved": "Webhook Saved",
        "recipientsPlaceholder": "Add recipients to receive index rate alerts.",
        "recipientsCallout": "The owner of this organization’s email address has been automatically added to the recipient list below. In order to remove this recipient, add at least one other recipient first.",
        "email": {
          "label": "1 email selected",
          "label_plural": "{{count}} emails selected",
          "placeholder": "Type or select email recipients...",
          "selectLabel": "Press enter",
          "deselectLabel": "Press enter",
          "deselectBlockedLabel": "Can't remove this value",
          "tagPlaceholder": "Add this email"
        },
        "slack": {
          "label": "1 Slack recipient selected",
          "label_plural": "{{count}} Slack recipients selected",
          "placeholder": "Select Slack recipients...",
          "webhookPlaceholder": "Enter webhook URL...",
          "selectLabel": "Press enter",
          "deselectLabel": "Press enter",
          "tagPlaceholder": "Add this webhook URL",
          "popoverTitle": "Where do I get this URL?",
          "popoverContent": "Follow the instructions on <a href='https://get.slack.help/hc/en-us/articles/115005265063-Incoming-WebHooks-for-Slack'>this page</a>, and scroll to the section titled \"Set up incoming webhooks\". After completing step 4 (you can ignore step 5), copy the Webhook URL you get and paste that in here.",
          "connect": {
            "button": "Add from Slack"
          }
        },
        "pd": {
          "label": "1 PagerDuty recipient selected",
          "label_plural": "{{count}} PagerDuty recipients selected",
          "placeholder": "Select PagerDuty recipients...",
          "selectLabel": "Press enter",
          "deselectLabel": "Press enter",
          "connect": {
            "button": "Add from PagerDuty"
          }
        },
        "webhook": {
          "label": "1 Slack recipient selected",
          "label_plural": "{{count}} Slack recipients selected",
          "methodPlaceholder": "Select Method...",
          "methodAndUrl": "Method & URL",
          "headers": "Headers",
          "body": "Body",
          "validateJson": "Validate JSON",
          "tokens": "Tokens",
          "tokenHelpText": "Use the following tokens in the webhook body to access specific information about the trigger the alert",
          "tooltips": {
            "string": "This token returns a string value"
          },
          "tokenDescriptions": {
            "max_lines": "The number of lines required in order to trigger the alert.",
            "max_z_score": "The number of standard deviations above the 30 day average lines in order to trigger the alert.",
            "alert_trigger": "Value representing what triggered the alert. Returns 'Both', 'Max lines exceeded', or 'Max Z score exceeded",
            "current_index_rate": "Current value of the index rate",
            "current_ingest_rate": "Current value of the ingestion rate"
          },
          "urlRequired": "A webhook URL is required",
          "methodRequired": "A webhook method is required",
          "bodyValid": "Webhook body is valid json.",
          "bodyInvalid": "Webhook body is invalid json."
        }
      },
      "errors": {
        "noThresholds": "Set up at least one threshold to enable Index Rate Alerts",
        "noRecipients": "Set up at least one recipient to enable Index Rate Alerts",
        "noFrequency": "Set up alert frequency to enable Index Rate Alerts"
      },
      "states": {
        "featureDisabled": "Index Rate Alerts are currently disabled.",
        "noneThresholdsConfiguredAndNoRecipientsAdded": "Set at least one threshold and add at least one recipient to activate this feature.",
        "noneThresholdsConfigured": "Set at least one threshold to activate this feature.",
        "noRecipientsAdded": "Add at least one recipient to activate this feature.",
        "bothThresholdsConfiguredAlertSeparately": "The max lines/s and max z-score thresholds are configured to separately alert recipients when exceeded.",
        "bothThresholdsConfiguredAlertTogether": "The max lines/s and max z-score thresholds are configured to jointly alert recipients only when both are exceeded.",
        "absoluteThresholdConfigured": "The max lines/s thresholds is configured to alert recipients when exceeded.",
        "relativeThresholdConfigured": "The max z-score thresholds is configured to alert recipients when exceeded.",
        "bothThresholdsAlertingHourlyExceeded": "The max lines/s and max z-score thresholds have both been exceeded. Recipients will be alerted in hourly intervals until the lines/s and z-score decline below their thresholds.",
        "bothThresholdsAlertingDailyExceeded": "The max lines/s and max z-score thresholds have both been exceeded. Recipients will be alerted in daily intervals until the lines/s and z-score decline below their thresholds.",
        "bothThresholdsAlertingHourlyAbsoluteThresholdExceeded": "The max lines/s and max z-score thresholds have both been configured. The max lines/s threshold has been exceeded. Recipients will be alerted in hourly intervals until the lines/s declines below the threshold.",
        "bothThresholdsAlertingDailyAbsoluteThresholdExceeded": "The max lines/s and max z-score thresholds have both been configured. The max lines/s threshold has been exceeded. Recipients will be alerted in daily intervals until the lines/s declines below the threshold.",
        "bothThresholdsAlertingHourlyRelativeThresholdExceeded": "The max lines/s and max z-score thresholds have both been configured. The max z-score threshold has been exceeded. Recipients will be alerted in hourly intervals until the z-score declines below the threshold.",
        "bothThresholdsAlertingDailyRelativeThresholdExceeded": "The max lines/s and max z-score thresholds have both been configured. The max z-score threshold has been exceeded. Recipients will be alerted in daily intervals until the z-score declines below the threshold.",
        "absoluteThresholdAlertingHourlyExceeded": "The max lines/s threshold has been exceeded. Recipients will be alerted in hourly intervals until the lines/s declines below the threshold.",
        "absoluteThresholdAlertingDailyExceeded": "The max lines/s threshold has been exceeded. Recipients will be alerted in daily intervals until the lines/s declines below the threshold.",
        "relativeThresholdAlertingHourlyExceeded": "The max z-score threshold has been exceeded. Recipients will be alerted in hourly intervals until the lines/s declines below the threshold.",
        "relativeThresholdAlertingDailyExceeded": "The max z-score threshold has been exceeded. Recipients will be alerted in daily intervals until the lines/s declines below the threshold."
      }
    }
  },
  "organization": {
    "general": {
      "changeOwner": {
        "title": "Owner",
        "changeOwner": "Change Owner",
        "makeOwner": "Make Owner",
        "serverMessages": {
          "confirmationHasBeenSent": "{{ email }} has been sent a confirmation email"
        }
      },
      "privateEndpoints": {
        "title": "Private endpoints only",
        "description": "Disable use of public endpoints. When enabled, only private endpoints can be used. When disabled, both private and public endpoints can be used."
      },
      "deactivateLA": "Deactivating an account will purge all logging history. There is no 'undo' for this.",
      "deactivateLaAndPipeline": "Deactivating an account will purge all logging history and deactivate running pipelines. There is no 'undo' for this.",
      "deactivatePipeline": "Deactivating an account will deactivate all running pipelines. There is no 'undo' for this."
    },
    "enterpriseJoinConsent": {
      "title": "Enterprise Consent Signature",
      "description": "The Enterprise Consent Signature is used to associate this organization with an enterprise. Once the token is generated you will need to provide it to the Enterprise Admin for verification and association.",
      "enterpriseAccountIdLabel": "Enterprise Account Id",
      "generateKeyButton": "Generate Token",
      "enterpriseAccountIdHint": "The enterprise super admin will need to provide this id.",
      "copyKeyInstruction": "Copy this token and provide it to the enterprise super admin for verification and association.",
      "copied": "Copied",
      "noteTitle": "Note:",
      "noteKeysNotStored": "The token is not stored in the UI and are only visible after they are generated.",
      "noteInvalidation": "Generating a new signature token or changing the organization owner will invalidate existing consent signature.",
      "noteExpiration": "Consent signature tokens are only valid for 1 hour and can only be used once.",
      "error": "Unable to generate enterprise consent signature token"
    },
    "apiKeys": {
      "ingestion": {
        "title": "Ingestion Keys",
        "description": "The following keys are used for ingestion (write-only).",
        "generate": "Generate Ingestion Key",
        "keyTitle": "Ingestion Key"
      },
      "analysis": {
        "title": "Analysis Service Keys",
        "description": "The following service keys can be used for managing Log Analysis configuration via <a target='_blank' href='https://docs.$t(common:defaultHost)/log-analysis-api/ref#tag-configuration'>API</a> or <a href='https://docs.$t(common:defaultHost)/docs/terraform-provider' target='_blank'>Terraform</a>.",
        "generate": "Generate Service Key",
        "keyTitle": "Service Key",
        "deprecatedMessage": "Analysis keys are deprecated, please use Service keys instead. You can still use your existing Analysis keys, but they will be removed in the future."
      },
      "serviceAccounts": {
        "title": "Service Accounts",
        "keyTitle": "Service Account Key",
        "keyTrailer": "Key ending in",
        "description": "Service accounts are non-user identities with their own key and permissions. Use them for managing Log Analysis and Pipeline configurations via <a href='https://docs.mezmo.com/telemetry-pipelines/terraform-provider' target='_blank'>Terraform</a>, accessing all public API endpoints and deploying <a href='https://docs.mezmo.com/telemetry-pipelines/mezmo-edge' target='_blank'>Edge Pipelines</a>.",
        "create": "Create Service Account",
        "noAccounts": "No service accounts created yet.",
        "permissionMessage": "Only account admins and owners can create service accounts",
        "remaining": "{{ count }} remaining",
        "table": {
          "name": "Name",
          "access": "Access",
          "created": "Created",
          "actions": "Actions"
        },
        "access": {
          "none": "No permissions",
          "sameAsUser": "Same as your user's role",
          "permissionCount": "{{count}} permission",
          "permissionCount_plural": "{{count}} permissions",
          "additionalPermissionCount": "+{{count}} permission",
          "additionalPermissionCount_plural": "+{{count}} permissions"
        },
        "form": {
          "createTitle": "Create Service Account",
          "editTitle": "Edit Service Account",
          "nameLabel": "Service Account Name",
          "create": "Create"
        },
        "rotate": {
          "action": "Rotate key",
          "title": "Rotate the key for <strong>{{ name, sanitize }}</strong>?",
          "body": "The current key stops working immediately and a new one is generated. The new key is only shown once, so save it before leaving this page.",
          "confirm": "Yes, rotate"
        },
        "reveal": {
          "createdTitle": "New {{ keyTitle }}",
          "rotatedTitle": "{{ keyTitle }} rotated",
          "warning": "Copy this key now and store it somewhere safe. For security reasons it won't be shown again.",
          "copy": "Copy",
          "copied": "Copied",
          "done": "Done"
        },
        "deleteTitle": "Delete the {{ entity }} <strong>{{ name, sanitize }}</strong>?",
        "entity": "service account",
        "inUseByAgent": {
          "title": "Cannot delete service account",
          "before": "This service account is currently being used by a",
          "link": "Governance Agent",
          "after": "and cannot be deleted."
        }
      },
      "deleteKeyTitle": "Delete the {{ type }} <strong>{{ key, sanitize }}</strong>?",
      "copyToClipboard": "Copy to clipboard",
      "copiedToClipboard": "Copied to clipboard",
      "saveKeyTooltip": "Save this key. You won't be able to see this again.",
      "showKey": "Show Key",
      "noKeys": "No keys generated yet.",
      "keysTable": {
        "name": "Name",
        "ingestionKey": "Ingestion Key",
        "serviceKey": "Service Key",
        "generated": "Generated"
      },
      "keyPermissionMessage": "Only account admins and owners can generate {{ key }}",
      "keysRemaining": "{{ count }} remaining",
      "errors": {
        "emptyKeyName": "Key name cannot be empty"
      }
    },
    "whitelistDomains": {
      "pageTitle": "CORS Origins",
      "deleteDomainTitle": "Delete the domain <strong>{{ domain }}</strong> from the CORS origins?",
      "deleteDomain": "delete domain",
      "subTitle": "The following domains will be permitted to make CORS requests to our servers.",
      "noDomains": "No domains added yet.",
      "enterDomain": "Enter a domain...",
      "addDomain": "Add Domain"
    },
    "exportConfig": {
      "exportConfiguration": "Export configuration",
      "exportConfigurationHint": "Download a JSON file containing any combination of this account's Views (including Filters), Alerts, Boards, Screens, Exclusion rules, and Parsing templates.",
      "emptyAccountAlert": "Your account has nothing to export at this time.",
      "submitButton": "Export",
      "searchPlaceholder": "Find a configuration",
      "emptySearchResult": "No results found",
      "clearSearch": "Clear search",
      "exportForTemplateLibrary": " Export for template library (GM only)",
      "tree": {
        "views": "Views",
        "boards": "Boards",
        "screens": "Screens",
        "exclusions": "Exclusion rules",
        "defaultExclusionName": "Untitled rule",
        "templates": "Parsing templates",
        "alerts": "Include alert",
        "uncategorized": "UNCATEGORIZED",
        "summary": {
          "views": "1 view",
          "views_plural": "{{ count }} views",
          "alerts": "1 alert",
          "alerts_plural": "{{ count }} alerts",
          "boards": "1 board",
          "boards_plural": "{{ count }} boards",
          "screens": "1 screen",
          "screens_plural": "{{ count }} screens",
          "exclusions": "1 rule",
          "exclusions_plural": "{{ count }} exclusions",
          "templates": "1 template",
          "templates_plural": "{{ count }} templates"
        }
      }
    },
    "importConfig": {
      "importConfiguration": "Import configuration",
      "importConfigurationHint": "Upload a JSON file containing any combination of Views (including Filters), Alerts, Boards, Screens, Exclusion rules, and Parsing templates.",
      "submitButton": "Import",
      "uploadFileButton": "Upload another file",
      "confirmImport": "Confirm import",
      "dropJson": "Drop JSON config file here or click to upload",
      "replaceExisting": "existing configuration",
      "addTo": "to existing configuration",
      "importWarning": "<p>This import operation will replace any current configurations of <strong>{{ org }}</strong> organization that are of the same type as those you are importing. </p> <p>For example, if you are importing new views, all existing views in your account will be removed, and replaced with the imported views. </p> <p><b>You may want to save your current configuration, in case you want to revert your changes.</b></p>",
      "learnMore": "Learn more about what happens when you <a href='https://docs.$t(common:defaultHost)/docs/importing-and-exporting-organization-configurations#to-import-configurations' target='_blank'>add or replace</a> existing configuration.",
      "successfulImport": "Import successful! View the <strong>before</strong> and <strong>after</strong> count summaries below. Note that you must wait 10 minutes before importing another file to prevent collisions.",
      "partiallySuccessfulImport": "Import partially successful. View the <strong>before</strong> and <strong>after</strong> count summaries below to see which configurations didn’t import. Note that you must wait 10 minutes before importing another file to prevent collisions.",
      "unsuccessfulImport": "Import unsuccessful. View the summaries below to see which configurations didn’t import. Note that you must wait 10 minutes before importing another file to prevent collisions.",
      "parseError": "Encountered an unknown error while trying to parse {{name}}",
      "uploadTimeout": "Parsing your file took longer than expected. Please try again.",
      "toSeeChanges": "your browser to see the configuration changes.",
      "summary": {
        "titles": {
          "configurations": "Configurations",
          "before": "before",
          "after": "after"
        },
        "configurations": {
          "viewsAndAlerts": "Views and Alerts",
          "boards": "Boards",
          "screens": "Screens",
          "exclusions": "Exclusion rules",
          "templates": "Parsing templates"
        },
        "collections": {
          "views": "1 view",
          "views_plural": "{{ count }} views",
          "alerts": "1 alert",
          "alerts_plural": "{{ count }} alerts",
          "boards": "1 board",
          "boards_plural": "{{ count }} boards",
          "screens": "1 screen",
          "screens_plural": "{{ count }} screens",
          "exclusions": "1 rule",
          "exclusions_plural": "{{ count }} exclusions",
          "templates": "1 template",
          "templates_plural": "{{ count }} templates"
        }
      },
      "errors": {
        "accountMismatch": "Oops, there was an account context mismatch. This can usually be resolved by signing out and then signing back in again.",
        "invalidJson": "Oops, your JSON file is invalid.",
        "sameAccount": "Oops, you attempted to <strong>add</strong> your configuration file into the same account that it was exported from. In order to prevent duplications, we currently only allow you to <strong>replace</strong> configurations when importing a file back into the same account.",
        "modifiedJson": "Oops, the JSON configuration file you uploaded appears to have been modified after it was exported. Please try again with an unaltered configuration file.",
        "invalidConfig": "Oops, the file you uploaded failed validation, please contact  <a href='mailto:support@$t(common:defaultHost)'>support@$t(common:defaultHost)</a> if you believe this is in error.",
        "coolOff": "You recently imported another configuration file and your account is in a cool off period to prevent import collisions. You may import new files in 10 minutes.",
        "boardsNotAvailable": "Graphing only available under paid plans.",
        "screensNotAvailable": "Screens only available under paid plans.",
        "exclusionsNotAvailable": "Exclusion rules only available under paid plans.",
        "alertsNotAvailable": "Alerting only available under paid plans.",
        "boardsPartialSuccess": "The following Boards did not import successfully:",
        "screensPartialSuccess": "The following Screens did not import successfully:",
        "templatesPartialSuccess": "The following Templates did not import successfully:",
        "exclusionsPartialSuccess": "The following Exclusion Rules did not import successfully:",
        "alertsPartialSuccess": "The following Views and/or Alerts did not import successfully:",
        "viewsPartialSuccess": "The following Views and/or Alerts did not import successfully:",
        "boardsFailure": "None of your Boards imported successfully:",
        "screensFailure": "None of your Screens imported successfully:",
        "templatesFailure": "None of your Templates imported successfully:",
        "exclusionsFailure": "None of your Exclusion Rules imported successfully:",
        "alertsFailure": "None of your Views and/or Alerts imported successfully:",
        "viewsFailure": "None of your Views and/or Alerts imported successfully:"
      }
    }
  },
  "alerts": {
    "deleteAlertTitle": "Delete the <strong>{{ name }}</strong> alert preset?",
    "detachAlertTitle": "Detach all alerts from the <strong>{{ name }}</strong> view?",
    "detachAlertOkTitle": "Yes, detach"
  },
  "customParsing": {
    "parsingTemplates": "Parsing Templates",
    "createTemplate": "Create Template",
    "noTemplates": "No Templates",
    "placeholder": "Find Templates",
    "name": "Template Name",
    "status": "Status",
    "notChosen": "Log line is not chosen yet",
    "incomplete": "Incomplete parsing template",
    "missingValidation": "Missing validation",
    "draft": "Draft",
    "deleteModalTitle": "Delete <strong>{{ name }}</strong> custom template?",
    "warning": "Please allow up to 15 minutes for changes to active templates to take effect",
    "helpMessage": "Lines are custom parsed based on the order of active templates. For more details, please check our <a href=\"https://docs.$t(common:defaultHost)/docs/parse-logs-with-custom-templates\" target=\"_blank\">Custom Log Parser guide</a>.",
    "showActive": "Show Active",
    "showDraft": "Show Draft"
  },
  "team": {
    "members": {
      "title": "Users",
      "inviteMember": "Invite User",
      "inviteMemberModal": {
        "title": "Invite New User",
        "label": {
          "email": "Email",
          "role": "Roles"
        },
        "userExistError": "This user is already part of the team."
      },
      "memberModal": {
        "editTitle": "Edit User",
        "rolesPlaceholder": "Select roles",
        "ownerChangeHint": "The account owner can be changed under",
        "ownerChangeHintLink": "Settings > Organization > General"
      },
      "roles": {
        "owner": "Owner",
        "admin": "Admin",
        "member": "Member",
        "readonly": "Read-only"
      },
      "deleteConfirmation": "Delete <strong>{{ email }}</strong> from your team?",
      "quotaReachedCallout": {
        "content": "You have reached the maximum number of users permitted by the <strong>{{ plan }}</strong> plan.",
        "please": "Please",
        "upgradePlan": "upgrade your plan",
        "toUnlockMoreMembers": "to unlock more users.",
        "ownerEmail": " Please ask your account owner <a href='{{ link }}'>{{ email }}</a> to upgrade your plan to unlock more users."
      },
      "filter": {
        "searchPlaceholder": "Search users...",
        "noResultsTitle": "No Results Found",
        "noResultsMessage": "The filters selected returned no results."
      },
      "table": {
        "fields": {
          "email": "Email",
          "roles": "Roles"
        },
        "email": {
          "you": "you"
        },
        "roles": {
          "none": "None"
        }
      },
      "noResultsTitle": "No Results Found",
      "noResultsMessage": "The filters selected returned no results."
    },
    "settings": {
      "discover": "Discover",
      "discoverabilityDisabled": "Discoverability of this organization is disabled in the Enterprise settings.",
      "allowMembersToDiscover": "allow users with an <strong>{{ domains }}</strong> email to discover this organization."
    }
  },
  "integration": {
    "usedBy": "Used by",
    "viewLabel": "{{ name }} view",
    "iraLabel": "Index Rate Alerts",
    "quotasLabel": "Usage Quotas",
    "github": {
      "connectedAs": "Connected as",
      "noReposCallout": "No repositories could be found using your credentials.",
      "connectButton": "Connect to Github",
      "repositoriesHeader": "Repositories to Monitor",
      "insufficientPermissions": "insufficient permissions to create webhook",
      "grantedBy": "granted by"
    },
    "pagerduty": {
      "servicesTitle": "PagerDuty Services",
      "addService": "Add PagerDuty service",
      "noServicesCallout": "No PagerDuty services are integrated with this account.",
      "filterPlaceholder": "Find services",
      "noFilteredServices": "No services",
      "nameAndKey": "Name and key",
      "deleteService": "Delete service",
      "deleteServiceTitle": "Delete <strong>{{ service.subdomain }}/{{ service.serviceName }}</strong> ({{ service.serviceKey }})?",
      "deleteServiceContent": "Deleting {{ service.subdomain }}/{{ service.serviceName }} will also remove this PagerDuty service from existing view alerts and index rate alerts.",
      "deleteSuccess": "Service deleted",
      "deleteError": "An error occurred while trying to delete this service."
    },
    "slack": {
      "channelsTitle": "Slack Channels",
      "addChannel": "Add Slack channel",
      "noHooksCallout": "No Slack channels are integrated with this account.",
      "channelFilterPlaceholder": "Find channels",
      "webhookFilterPlaceholder": "Find webhooks",
      "noFilteredChannels": "No channels",
      "noFilteredWebhooks": "No webhooks",
      "channelAndId": "Channel and ID",
      "webhookTitle": "Slack Webhooks",
      "url": "URL",
      "deleteChannel": "Delete channel",
      "deleteWebhook": "Delete webhook",
      "deleteModalTitle": "Delete <strong>{{ channel }}</strong>?",
      "deleteModalContent": "Deleting {{ channel }} will also remove this Slack channel from existing view alerts, index rate alerts, and usage quotas.",
      "deleteSuccess": "Channel deleted",
      "deleteError": "An error occurred while trying to delete this channel."
    }
  }
}
